import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { getOnHotkeyToggleNodeTypeDefault } from '../../helpers/toggleBlockAtSelection';
import { DEFAULT_HIGHLIGHT, DEFAULT_HIGHLIGHT_COLORS, ELEMENT_HIGHLIGHT } from './defaults';
import { renderHighlightElement } from './renderElement';
import { HighlightElementPluginOptions } from './types';

const deserializeHighlightElement = (el) => {
  if (el && el?.classList?.contains('highlight-element-wrapper')) {
    const nodeColoKey =
      typeof el?.getAttribute === 'function' && el.getAttribute('data-highlight-color-key');

    return { type: ELEMENT_HIGHLIGHT, highlightKey: nodeColoKey };
  }
  return undefined;
};

export const HighlightElementPlugin = (options?: HighlightElementPluginOptions): SlatePlugin => {
  return {
    renderElement: renderHighlightElement(options),
    inlineTypes: [ELEMENT_HIGHLIGHT],
    onKeyDown: getOnHotkeyToggleNodeTypeDefault({
      key: ELEMENT_HIGHLIGHT,
      defaultOptions: DEFAULT_HIGHLIGHT,
      options: {
        [ELEMENT_HIGHLIGHT]: {
          extraProps: {
            highlightKey: DEFAULT_HIGHLIGHT_COLORS.yellow40.key,
          },
        },
      },
    }),
    deserialize: {
      element: [
        {
          type: 'highlight-element',
          deserialize: deserializeHighlightElement,
        },
      ],
    },
  };
};
